import React, { useCallback, useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';

import IntegrationButton from './IntegrationButton';
import Modal from '../../../components/Modal';
import { FormProvider, useForm } from 'react-hook-form';
import useThrottle from '../../../utils/use-throttle';
import ControlledInput from '../../../components/ControlledInput';
import BtnFilled from '../../../components/BtnFilled';
import { updateMosru } from '../../../api/api';
import { toast } from 'react-toastify';

const MosruEditButton = ({ pay_code, send_at_day, integration_id }) => {
  const [modal, setModal] = useState(false);
  const methods = useForm({ mode: 'onTouched', defaultValues: { send_at_day: null, pay_code: '' } });

  useEffect(() => {
    const get = async () => {
      methods.setValue('pay_code', String(pay_code ?? ''));
      methods.setValue('send_at_day', send_at_day);
    };
    get();
  }, []);

  const inputsFields = [
    {
      name: 'send_at_day',
      label: 'День отправки показаний в mos.ru',
      placeholder: 'Введите день месяца (1–28)',
      type: 'text',
      mask: '99',
      rules: {
        pattern: {
          value: /^\s*(?:[1-9]|1\d|2[0-8])\s*$/,
          message: 'Введите число от 1 до 28',
        },
      },
    },
    { name: 'pay_code', label: 'Код плательщика в mos.ru', placeholder: 'Укажите код плательщика', type: 'text' },
  ];

  const handleSuccess = useThrottle(() => {
    toast.success('Интеграция успешно обновлена!');
    methods.reset();
    setModal(false);
  }, 1000);

  const handleSubmit = useThrottle(async (data) => {
    const filteredObj = Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== ''));
    filteredObj.send_at_day = parseInt(filteredObj?.send_at_day);
    await updateMosru(integration_id, filteredObj, handleSuccess, (err) => toast.error(err.error ?? 'Произошла ошибка во время отправки'));
  }, 500);

  return (
    <>
      <IntegrationButton Icon={EditIcon} handleClick={() => setModal(true)} label={'Обновить данные'} />
      <Modal showModal={modal} setShowModal={setModal} title="Обновление данных в Mos.ru" showSave={false} classWidth="relative w-[468px] my-3 mx-2">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            {inputsFields.map((input, i) => {
              return <ControlledInput key={input.name} classContainer={'mb-4'} {...input} />;
            })}
            <BtnFilled disabled={!methods.formState.isDirty} className={'mt-2'} type={'submit'} title="Сохранить" />
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};

export default MosruEditButton;
